var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"d-back-button button",class:_vm.buttonClass,attrs:{"title":"Back"},on:{"click":function($event){return _vm.goBack()}}},[_c('DuiIconArrowLeft',{class:_vm.vm.iconClass})],1)}
var staticRenderFns = []

export { render, staticRenderFns }